import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const CardBody = ({ children }: Props) => {
  return <div styleName="card-body">{children}</div>;
};

export default CardBody;
